<script setup lang="ts">
import { IonRouterOutlet, IonPage, IonContent } from "@ionic/vue";
</script>

<template>
  <ion-page>
    <ion-content>
      <ion-router-outlet />
    </ion-content>
  </ion-page>
</template>
